import {JSX} from "react";

import {StarRating} from "@/shared/ui/data-display/rating";

import "./styles/single-review.scss";

interface SingleReviewProps {
    name: string;
    rating: number;
    date: string;
    reviewText: string;
    managerResponse?: string;
    className?: string;
    cardView?: boolean;
}

export function SingleReview({name, rating, date, reviewText, managerResponse, className = "", cardView = false}: SingleReviewProps): JSX.Element {
    if (cardView) {
        const normalizedRating = Math.max(0, Math.min(5, rating));
        return (
            <div className={`single-review ${className} card-view`}>
                <p className="single-review__name">{name}</p>
                <div className="single-review__meta">
                    <div className="star-rating__stars stars--medium" style={{"--rating": normalizedRating} as React.CSSProperties} />
                    <span className="single-review__score">{normalizedRating}/5</span>
                </div>

                <p className="single-review__text" dangerouslySetInnerHTML={{__html: reviewText}} />

                {managerResponse && (
                    <div className="single-review__manager-response">
                        <p className="single-review__manager-label">Manager response:</p>
                        <p className="single-review__manager-text" dangerouslySetInnerHTML={{__html: managerResponse}} />
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={`single-review ${className}`}>
            <StarRating name={name} rating={rating} date={date} size="medium" />

            <p className="single-review__text" dangerouslySetInnerHTML={{__html: reviewText}} />

            {managerResponse && (
                <div className="single-review__manager-response">
                    <p className="single-review__manager-label">Manager response:</p>
                    <p className="single-review__manager-text" dangerouslySetInnerHTML={{__html: managerResponse}} />
                </div>
            )}
        </div>
    );
}
